/**
 * CarerContractTypeFetcher
 *
 * @author Dec Norton <decnorton@gmail.com>
 */

import { Fetcher } from '../../fetchers/fetcher';

class CarerContractTypeFetcher extends Fetcher {
    get modelName() {
        return 'Carer Contract Type';
    }

    get resourceName() {
        return 'carer-contract-types';
    }
}

export function carerContractTypeFetcherProvider() {
    this.$get = instantiateFetcher;

    instantiateFetcher.$inject = ['$injector'];

    function instantiateFetcher($injector) {
        return $injector.instantiate(CarerContractTypeFetcher);
    }
}
